// import type { Components } from '@mui/material/styles';

export default function MuiSlide() /*: Components['MuiSlide'] */ {
  return {};
}
